import type { CharacterWithStats } from '@shared/types'
import type { CalcInput } from '@shared/rules/calc'

/** Everything deriveStats() needs, pulled off a loaded character. */
export function calcInputOf(character: CharacterWithStats): CalcInput {
  return {
    level: character.level,
    class: character.class,
    scores: character.scores,
    saveProficiencies: character.saveProficiencies,
    skillProficiencies: character.skillProficiencies,
    armorClass: character.armorClass,
    acIsManual: character.acIsManual,
    initiativeBonus: character.initiativeBonus,
  }
}

/** The fields the sheet's edit mode is allowed to send back. */
export const EDITABLE_FIELDS = [
  'name', 'class', 'subclass', 'level', 'species', 'background', 'alignment',
  'scores', 'hpMax', 'armorClass', 'acIsManual', 'speed', 'initiativeBonus',
  'saveProficiencies', 'skillProficiencies', 'otherProficiencies', 'features', 'notes', 'xp',
] as const

export function editablePayload(character: CharacterWithStats): Record<string, unknown> {
  const payload: Record<string, unknown> = {}
  for (const field of EDITABLE_FIELDS) payload[field] = character[field]
  return payload
}
